module.exports = (__parcel__import__("eW2bW")).then(() => parcelRequire('fyWP3'));